export default "__VITE_ASSET__Xdu_TZwP__"